const DENOMS = [5_000, 10_000, 50_000, 100_000];

/** Round-up cash suggestions strictly above the bill, deduped, max 3 (62 700 → 65 000 · 70 000 · 100 000). */
export const suggestCash = (total: number): number[] =>
    [...new Set(DENOMS.map((d) => (Math.floor(total / d) + 1) * d))].sort((a, b) => a - b).slice(0, 3);
